import { paths } from '../../galaxyClient/types/Content';

export enum POST_STATUS {
  PUBLISHED = 'PUBLISHED',
  SCHEDULED = 'SCHEDULED',
  DELETED = 'DELETED',
  DRAFT = 'DRAFT',
  PENDING = 'PENDING',
}

export enum MEDIA_TYPE {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  TEXT = 'TEXT',
  DOCUMENT = 'DOCUMENT',
}

export type SubmitPostBody = Extract<
  paths['/v2/posts/']['post']['requestBody'],
  object
>['content']['application/json'];

export type ListPostsResponse =
  paths['/v2/posts/']['get']['responses']['200']['content']['application/json'];

export type Post = Extract<ListPostsResponse['result'], object>[0];
export type PostAsset = Extract<Post['assets'], object>[0];
export interface PublishedPostResponse extends Omit<Post, 'publishedAt'> {
  publishedAt?: Date;
  scheduledDate?: Date;
  authorName?: string;
  files: RawFileSrc[];
  externalPostId: string;
}

export interface RawFileSrc {
  type: MEDIA_TYPE;
  src: string;
}
